export const MESSAGES: Messages = {
  CREATE: {
    SUCCESS: {
      variant: "default",
      description: "NCM criado com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao criar NCM.",
      duration: 5000,
      closeOnClick: true,
    },
  },
};
